import {Component, EventEmitter, OnDestroy, OnInit, Output} from "@angular/core";
import * as fromStore from '../../../store';
import {Store} from "@ngrx/store";
import {ActivityStatus} from "../../../activities/activity";
import {combineLatest} from "rxjs";
import {UserSubscription} from "../../../user/user-subscription";
import MigrationSlides from "./migration-slides.json";
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {User} from "../../../user/user";
import {Subject} from "rxjs";

@Component({
    selector: 'db-migration-progress',
    templateUrl: './migration-progress.component.html',
    styleUrls: ['./migration-progress.component.scss'],
    standalone: false
})
export class MigrationProgressComponent implements OnInit, OnDestroy {

  @Output() resized = new EventEmitter<number>();
  @Output() succeed = new EventEmitter<{ websiteId: number, data: any }>();
  @Output() failed = new EventEmitter<void>();

  public user: User;
  public userSubscription: UserSubscription;
  public websiteId: number;
  public slides = MigrationSlides;
  public slideCheckedId: number = 0;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _store: Store<fromStore.DbStoreState>,
  ) {
  }

  ngOnInit() {
    this.resized.emit(1000);
    this._runSlide();
    this._getUserData();
    this._getOngoingActivities();
  }

  private _getUserData(): void {
    combineLatest(
      this._store.select(fromStore.getUser),
      this._store.select(fromStore.getUserSubscription)
    )
      .pipe(first(([user, userSubscription]) => !!user && !!userSubscription))
      .subscribe(([user, userSubscription]) => {
        this.user = user;
        this.userSubscription = userSubscription;
      });
  }

  private _runSlide(): void {
    setInterval(() => {
      this.slideCheckedId = this.slideCheckedId === this.slides.length - 1 ? 0 : this.slideCheckedId + 1;
    }, 5000);
  }

  public prevSlide(): void {
    this.slideCheckedId = this.slideCheckedId === 0 ? this.slides.length - 1 : this.slideCheckedId - 1;
  }

  public nextSlide(): void {
    this.slideCheckedId = this.slideCheckedId === this.slides.length - 1 ? 0 : this.slideCheckedId + 1;
  }

  private _getOngoingActivities(): void {
    const subscription = this._store.select(fromStore.getOngoingActivities)
      .pipe(
        first(loaded => !!loaded),
        switchMap(() => this._store.select(fromStore.getMigrationOngoingActivity)),
        filter(activity => activity && !!activity.status && [ActivityStatus.DONE, ActivityStatus.FAILED].includes(activity.status as ActivityStatus)),
        takeUntil(this._destroyStream$)
  )
      .subscribe((activity) => {

        switch (activity.status) {
          case ActivityStatus.DONE:
            subscription && subscription.unsubscribe();
            this.websiteId = activity.websiteId;
            this._store.dispatch(new fromStore.LoadInfo(this.websiteId));
            this.succeed.emit({websiteId: this.websiteId, data: activity.meta});
            break;

          case ActivityStatus.FAILED:
            subscription && subscription.unsubscribe();
            this.failed.emit();
            break;
        }
      });
  }

  ngOnDestroy(): void {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

}
